/* istanbul ignore file */
import React from 'react';
import { getPathnameFromUrl } from '@noths/polaris-client-utils';
import { Button } from '@noths/polaris-design-system-core-components';
import type { GetServerSideProps } from 'next';

import { Seo } from 'src/components/atoms/Seo/Seo';
import { SKIP_CONTENT_TARGET_ID } from 'src/constants/elementIds';
import { getFeatureFlagsWithMatchers } from 'src/featureFlags/getFeatureFlagsWithMatchers';
import { fetchGlobalContent } from 'src/services/contentstack/fetchGlobalContent';
import * as styles from 'src/styles/giftCards.styles';

const title = 'Gift Cards';
const copy =
  'Not sure if they prefer brownies or macarons? White or red? Fresh flowers or dried? Give them what they really, really want with a Not On The High Street gift card.';

const GiftCards = () => (
  <>
    <Seo description={copy} title={title} />
    <div css={styles.container} id={SKIP_CONTENT_TARGET_ID}>
      <h1>{title}</h1>
      <p>{copy}</p>
      <div css={styles.linksWrapper}>
        <Button href="https://giftcards.notonthehighstreet.com/digital">Email a Gift Card</Button>
        <Button href="https://giftcards.notonthehighstreet.com/balance-check">Check Balance</Button>
      </div>
      <div css={styles.imageWrapper}>
        <img
          alt=""
          src="https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/bltda4eb5d46c7fc989/6a21652270de9a0a6a338031/Gift_card_banner_image.png"
        ></img>
      </div>
    </div>
  </>
);

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const featureFlags = (req && getFeatureFlagsWithMatchers(req)) || {};
  const pathname = getPathnameFromUrl(req.url ?? '');
  const [siteChromeContent] = await fetchGlobalContent({
    featureFlags,
    urlPath: pathname,
  });

  return {
    props: {
      siteChromeContent,
    },
  };
};

export default GiftCards;
